<template>
    <div id="contenedor-main-contrato-listado-estimaciones">
      <template
        v-if="!$vuetify.breakpoint.mobile">
        <desktop
          :estimaciones="estimaciones"
          :conceptos="conceptos"
          :contrato="contrato"
          :firmas="firmas"
          :programasobra="programasobra"
          :es-obra-financiada="esObraFinanciada"
          :solo-lectura="soloLectura">
        </desktop>
      </template>
      <template
        v-else>
        <mobile
          :estimaciones="estimaciones">
        </mobile>
      </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainContratoListadoEstimaciones',
  props: {
    estimaciones: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
    programasobra: {
      type: Array,
      required: true,
    },
    esObraFinanciada: {
      type: Boolean,
      required: false,
      default: false,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
    conceptos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
